import React, { Component } from "react";
import { connect } from "react-redux";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { Col, Image, Row } from "react-bootstrap";
import editIcon from '../../assets/images/edit-icon.svg'
import deleteIcon from '../../assets/images/delete-icon.svg'
import { ComponentHeader, InformationModal, VerifiedModal } from "../common";
import { API_LIMIT, Ads, MODULE_ID_MAP, START_PAGE, isModuleExist, subAds } from "../../utils/Constant";
import { deleteAdsApi, getAllAdsApi } from "./Api";
import editPencil from "../../assets/images/edit-icon.png";
import { CONTENT_AD_VERIFY } from "../../utils/urls";
import FilterVefiedDropDown from "../common/FilterVefiedDropDown";
import { withRouter } from "../../utils/hoc/withRouter";
import { Tag } from "antd";
import OptionsDropdown from "../../utils/commonComponent/OptionsDropdown";


export class ContentAds extends Component {
  constructor(props) {
    super(props);
    const AccesData = isModuleExist(MODULE_ID_MAP.AdsContentAd);

    this.state = {
      access: AccesData,
      dummyData: [],
      pageSize: API_LIMIT,
      currentPage: START_PAGE,
      languageList: [],
      totalPages: null,
      delete: false,
      deleteData: {},
      editData: "",
      showEdit: false,

      isVerify: false,
      show: false,

      verified: '',
      verifyUrl: ''
    };
  }
  // todo---------------------------------------
  componentDidMount() {
    const { history } = this.props;
    history({
      pathname: this.props.location.pathname,
      search: `?p=${this.state.currentPage || START_PAGE}`,
    });
    this.props.getAllAdsApi(this);
  }
  // todo---------------------------------------

  openCloseDeleteModal = (rowData) => {
    this.setState({
      delete: !this.state.delete,
      deleteData: rowData,
    });
  };
  deleteHandle = (id) => {
    //  console.log("yes delete  this id",)
    deleteAdsApi(id, this, this.openCloseDeleteModal)
  }


  // todo:-----------------------------------------
  componentDidUpdate(prevProps, prevState) {
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
    const prevVerified = prevParams.get("isVerified") || "";
    const prevSize = parseInt(prevParams.get("pageSize"), 10) || API_LIMIT;


    const params = new URLSearchParams(this.props.location.search);
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    const verified = params.get("isVerified") || "";
    const size = parseInt(params.get("pageSize"), 10) || API_LIMIT;

    // const search = params.get("search") || "";

    if (prevPage !== page || prevVerified !== verified || prevParams.get("search") !== params.get("search") || prevSize !== size) {
      this.setState({ currentPage: page }, () => {
        this.props.getAllAdsApi(this);

      });
    }
  }
  // todo:-----------------------------------------



  render() {
    const { showEdit, access } = this.state;
    const { listData, totalPages, currentPage } = this.props.masterCategoryState;
    // const { contentList, totalPages, currentPage } = this.props.contentState;
    // console.log('AddContent-List',listData)
    return (
      <section className="request-section">
        {this.state.delete && (
          <InformationModal
            show={this.state.delete}
            id={this.state.deleteData.uuid}
            title={`Are you sure you want to delete  '${this.state.deleteData.contentAdName}' this Ads ?`}
            handleClose={this.openCloseDeleteModal}
            handleDelete={this.deleteHandle}
          />
        )}
        <VerifiedModal
          name={`'${this.state.editData?.contentAdName}'`}
          show={this.state.show}
          url={CONTENT_AD_VERIFY + `/${this.state?.editData?.uuid}`}
          isVerified={this.state.isVerify}
          handleCancel={() => { this.setState({ show: false }) }}
          successRes={() => { this.props.getAllAdsApi(this) }}
        />
        <ComponentHeader
          title="Content Ads"
          primaryBtn={access.createAccess ? "Add Ads" : ""}
          breadcrumb={[["Ads", ""], ["Content Ads", ""]]}
          handlePrimaryBtn={() => {
            this.props.history('/ads/content-ads/add');
            // this.setState({showEdit:true})
          }}
          ctx={this}
        />
        <Row>
          <Col sm={2}>
            <FilterVefiedDropDown ctx={this} />
          </Col>
        </Row>
        <div className="commom-table-wrapper">
          <CustomTable
          ctx={this}
            data={listData?.list || []}
            columns={[

              {
                width: 250,
                title: "Content Ad Name ",
                dataIndex: "contentAdName",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData.contentAdName;
                },
              },
              {
                width: access.verificationAccess ? 100 : 0,
                title: "Verified",
                dataIndex: "isVerified",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                 const color = rowData.isVerified ? 'green' : 'orange';
                    return <div className=" d-flex align-items-center inter-medium">
                      <Tag color={color}>{rowData.isVerified ? "YES" : "NO"}
                        <Image src={editPencil} onClick={() => this.setState({ show: true, isVerify: rowData.isVerified, editData: rowData })} className="edit-pencil-icon" alt="icon" />
                      </Tag>
                    </div>;
                },
              },
              {
                width: 150,
                title: "Ad Type",
                dataIndex: "adType",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData?.adType;
                },
              },
              {
                width: 200,
                title: "Keywords",
                dataIndex: "keywords",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData?.keywords?.join(', ');
                },
              },
              {
                width: 150,
                title: "Updated By",
                dataIndex: "updatedBy",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData?.updatedBy?.name || 'Na';;
                },
              },
              {
                width: 150,
                title: "Created By",
                dataIndex: "createdBy",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData?.createdBy?.name || 'Na';
                },
              },

              {
                width: 20,
                title: "Action",
                dataIndex: "",
                fixed: "right",
                className: "",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return (
                      // <div className="d-flex gap-4 justify-content-around">
                      //   {access.updateAccess &&
                      //     <Image src={editIcon} className="edit-icon" onClick={() => { this.props.history({ pathname: '/ads/content-ads/edit', state: { editData: rowData } }) }} />
                      //   }
                      //   {access.deleteAccess && (
                      //     <Image src={deleteIcon} className="edit-icon" onClick={() => { this.openCloseDeleteModal(rowData) }} />
                      //   )}
                      // </div>
                      <OptionsDropdown
                        editHandler={access.updateAccess ? ()=>{
                          this.props.history({ pathname: '/ads/content-ads/edit', state: { editData: rowData } })
                        } : null}
                        deleteHandler={access.deleteAccess? () => { this.openCloseDeleteModal(rowData) } : null}
                      />
                    );
                },
              },
            ]}
            
            total={listData?.length || 0}
              loading={this.state.isLoading}
          />
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  masterCategoryState: state.MasterCategoryState,
  // contentCollectionsState: state.ContentCollectionsState,
});
const mapDispatchToProps = {
  getAllAdsApi,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ContentAds));
